import { Badge } from '@/components/ui/badge'

type RubricCorpusHeroProps = {
  label: string
  methodologyId: string
  status: string
  version?: number
  validationMessage?: string | null
}

export function RubricCorpusHero({
  label,
  methodologyId,
  status,
  version,
  validationMessage,
}: RubricCorpusHeroProps) {
  return (
    <div className="rounded-lg border bg-muted/20 px-4 py-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="space-y-1">
          <h2 className="text-base font-semibold">{label}</h2>
          <div className="flex flex-wrap items-center gap-2">
            <Badge variant="outline">{status}</Badge>
            {version ? <Badge>v{version}</Badge> : null}
            <Badge variant="secondary">{methodologyId}</Badge>
          </div>
        </div>
        {validationMessage ? (
          <p className="max-w-md text-sm text-warning">{validationMessage}</p>
        ) : (
          <p className="text-sm text-muted-foreground">Draft validates — ready to publish when saved.</p>
        )}
      </div>
    </div>
  )
}
